import React from 'react';
import { Col, Modal, OverlayTrigger, Pagination, Row, Tooltip } from 'react-bootstrap';
import './ShipMaterial.scss';
import '../../../common/components/pagination/Pagination.scss'
import { Text } from '../../../common/components/text/Text'
import { Space } from '../../../common/components/space/Space';
import { Main } from '../../../common/components/main/Main';
import { Button } from '../../../common/components/button/Button';
import Card from '../../../common/components/card/Card';
import { Table } from '../../../common/components/table/Table';
import Icons from '../../../common/components/icon/Icon';
import { format, parseISO } from 'date-fns'
import { shipMaterialListGetAction, shipMaterialSetSelectedAction } from "../../../store/action/materialAction";
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { history } from '../../../store';
import { Flex } from '../../../common/components/flex/Flex';
import { ReactNode } from 'react'
import swal from 'sweetalert'
import materialService from '../../../services/materialService';
import Loader from 'react-loader-spinner';
import { InputWithIcon } from '../../../common/components/control/Control';
import { ShipFilterState } from '../filter/ShipFilterState';

const ShipMaterialList = (props: any) => {
  const { material, isLoading, totalElement } = props
  const [displayShips, setShips] = React.useState<any>([])
  const [page, setPage] = React.useState(0)
  const [pagination, setPagination] = React.useState([{}])
  const [searchQuery, setQuery] = React.useState('')
  const [low, setLow] = React.useState(1)
  const [high, setHigh] = React.useState(9)
  const perPage = 9
  var totalPage = Math.ceil(totalElement / 10)
  const [showDelete, setShow] = React.useState(false);
  const [deleteMaterial, setDeleteMaterial] = React.useState(0)
  const [searchInput, setSearchInput] = React.useState(ShipFilterState.shipMaterialfilter.searchBoxInputShipmaterial);

  // Used to get type and payload, call action and get list.   
  React.useEffect(() => {
    props.shipMaterialListGetAction({ size: 10, page, name: searchInput||ShipFilterState.shipMaterialfilter.searchBoxInputShipmaterial })
  }, [page, searchQuery])

  // Check ships(list) length, add checked false in that array.  
  React.useEffect(() => {
    // console.log(material, 'ship type in ship type lisst page')
    if (material && material.length > 0) {
      setShips(() => {
        return material.map((s: any) => ({ ...s, checked: false }))
      })
    }
    if (material && material.length === 0) {
      setShips([])
    }
  }, [material])

  // Get totalPage in props and push into the pagination variable.   
  React.useEffect(() => {
    const arrayPage = Array.from(Array(totalPage).keys())
    setPagination(arrayPage)
  }, [totalPage])

  // Redirect to ship detail page.  
  const _willViewDetail = (shipMaterial: any) => {
    shipMaterialSetSelectedAction(shipMaterial)
    history.push(`/shipMaterial/${shipMaterial.id}`)
  }

  // Redirect to ship edit page.  
  const _willViewEdit = (shipMaterial: any) => {
    props.shipMaterialSetSelectedAction(shipMaterial)
    history.push(`/shipMaterial/edit/${shipMaterial.id}`)
  }

  // Delete the pericular list.  
  const handleClose = () => setShow(false);
  const handleShow = (anode: any) => {
    setShow(true);
    setDeleteMaterial(anode.id)
    // console.log(deleteMaterial, 'deleted anode id')
  }

  const _willDelete = () => {
    // console.log(deleteMaterial, 'deleted anode id')
    _deleteMaterial(deleteMaterial)
  }

  const _deleteMaterial = (id: any) => {
    return materialService.deleteShipMaterial(id).subscribe({
      next: (r) => {
        // console.log(r, 'response')
        setShow(false);
        swal("Great", " Deleted Successfully", "success")
        props.shipMaterialListGetAction({ size: 10, page, name: searchInput })
      },
      error: err => {
        swal("OOPS", String(err), "error")
      }
    })
  }

  //search function 
  const _showAll = () => {
    setSearchInput('')
    props.shipMaterialListGetAction({ size: 10, page, name: '' })
  }

  const _searchFuntion = (value: string) => {
    setSearchInput(value)
    ShipFilterState.shipMaterialfilter.searchBoxInputShipmaterial=value;
    props.shipMaterialListGetAction({ size: 10, page, name: value })
    setPage(0)
  }

  // Prints first page pagination.  
  const firstPage = () => {
    if (page >= 1) {
      return <Pagination.First onClick={() => _goToFirstPage()}>First</Pagination.First>
    }
  }

  // While click the last page its move to last page.  
  const _goToLastPage = () => {
    setPage(totalPage - 1)
    setHigh(totalPage - 1)
    setLow(totalPage - 9)
  }

  // While click the first button its move to first page.  
  const _goToFirstPage = () => {
    setPage(0)
    setHigh(9)
    setLow(1)
  }

  // Prints last page pagination button.  
  const lastPage = () => {
    if (page !== totalPage - 1) {
      if (page <= high) {
        return <Pagination.Last onClick={() => _goToLastPage()}>Last</Pagination.Last>
      }
    }
  }

  // Prints prev button.  
  const prevBtn = () => {
    if (page >= 1) {
      if (page + 1 === low) {
        setHigh(high - perPage)
        setLow(low - perPage)
      }
      return <Pagination.Prev onClick={() => _goPrevPage()}>Prev</Pagination.Prev>
    }
  }

  // While click prev button go to the previous page of current page.  
  const _goPrevPage = () => {
    setPage(prev => {
      const newValue = prev - 1
      return newValue
    })
  }

  // Print next button.  
  const nextBtn = () => {
    if (page < totalPage - 1) {
      if (page <= high) {
        return <Pagination.Prev onClick={() => _goNextPage()}>Next</Pagination.Prev>
      }
      else {
        setHigh(high + perPage)
        setLow(low + perPage)
      }
    }
  }

  // While click next page button go to the next page of the current page.  
  const _goNextPage = () => {
    setPage(prev => {
      const newValue = prev + 1
      return newValue
    })
  }

  // While click one page number its move to that page.  
  const _goToPage = (page: any) => {
    setPage(page)
  }

  // Return the page number
  const ListItem = (page: any) => {
    return page.value + 1
  }

  // Prints the totalpages between prev, next button.  
  const PageNumber = pagination.map((p, i) => {
    var pagination_num: ReactNode;
    if ((p === 0 && page === 0)) {
      pagination_num = <Pagination.Item onClick={() => _goToPage(p)} active={p === page} key={i}><ListItem value={p} /></Pagination.Item>
    }
    else if ((p < high + 1) && (p >= low - 1)) {
      pagination_num = <Pagination.Item onClick={() => _goToPage(p)} active={p === page} key={i}><ListItem value={p} /></Pagination.Item>
    }
    return (
      pagination_num
    )
  })

  return (
    <Main>
      <Text variant="title" color='black'>Ship Material List</Text>
      <Space divheight={15} />
      <Card>
        <SearchForm>
          <Row className='m-0 p-0'>
            <Col xs='12' sm='12' md='12' lg='4' xl='4' className='m-0 p-0'>
              <div className='mr-2 mb-2 mb-sm-2 mb-md-2 mb-lg-0 mb-xl-0'>
                <Row className='m-0 p-0'>
                  <Col xs='12' sm='10' md='9' lg='12' xl='12' className='m-0 p-0'>
                    <InputWithIcon
                      type="text"
                      value={searchInput}
                      onChange={(e) => _searchFuntion(e.target.value)}
                      placeholder="Search by Ship Material..."
                      icon="search"
                      id="search-inputMaterial"
                    />
                  </Col>
                </Row>
              </div>
            </Col>
            <Col xs='12' sm='12' md='12' lg='7' xl='7' className='m-0 p-0'>
              <Row className='m-0 p-0'>
                <Col xs='6' sm='4' md='4' lg='3' xl='3' className='m-0 p-0 mr-4'>
                  <Link to='/shipMaterial/add'>   {/* Button add new ship, if you click the button it shows modal box.   */}
                    <Button variant='transparent' block={true}>
                      <Icons color="#ffffff" icon="add" />
                      ADD SHIP MATERIAL
                    </Button>
                  </Link>
                </Col>
                <Col xs='5' sm='4' md='4' lg='3' xl='3' className='m-0 p-0 '>
                  <div>
                    <Button className='ml-4' variant='transparent' block={true} onClick={() => _showAll()}>
                      Show All
                    </Button>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </SearchForm>
        <Space divheight={30} />
        {isLoading && <Text center>
          <Loader
            type="Rings"
            color="#233269"
            height={100}
            width={100}
            timeout={30000}
          />
        </Text>} {/* Check the list is loading, isloading is true its shows loading text.  */}
        {!isLoading && displayShips.length === 0 && (
          <>
            <Space divheight={20} />
            <Text center>No ship Material found</Text>
            <Space divheight={20} />
          </>
        )} {/* If isloading is false and also the list array length is 0 its shows no discount fount text.   */}
        {!isLoading && displayShips.length > 0 && (
          <>
            <Table>
              <thead>
                <tr key={0}>
                  <th>S.No</th>
                  <th>Name</th>
                  <th>Name in English</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                {/* Map the list array and display the datas in a table.   */}

                {/* {console.log(displayShips)} */}
                {displayShips.map((data: any, i: any) => (
                  <tr key={data.id}>
                    {/* {console.log(data)} */}
                    <td data-label='S.No'>
                      {page === 0 && (
                        i + 1
                      )}
                      {page >= 1 && (
                        (page * 10) + (i + 1)
                      )}
                    </td>
                    <td data-label='Ship Material'>
                      {data.name === null ? (
                        <Text color='tabledata' variant='subtitle'> - </Text>
                      ) : (
                        <Text color='tabledata' variant='subtitle'>{data.name}</Text>
                      )}
                    </td>
                    <td data-label='Ship Material in English'>
                    {data.name_english === null ? (
                        <Text color='tabledata' variant='subtitle'> - </Text>
                    ):(
                      <Text color='tabledata' variant='subtitle'>{data.name_english}</Text>
                    )}
                    </td>
                    <td>
                      <TableActions>
                        <OverlayTrigger overlay={
                          <Tooltip id="shipmaterial-view"> View
                          </Tooltip>
                        }>
                          <Button className='link_button' onClick={() => _willViewDetail(data)}> {/* While onclick open view page.   */}
                            <Icons color="#52575a" icon="visibility" /> {/* View icon.  */}
                          </Button>
                        </OverlayTrigger>
                        <OverlayTrigger overlay={
                          <Tooltip id="shipmaterial-edit"> Edit
                          </Tooltip>
                        }>
                          <Button className='link_button' onClick={() => _willViewEdit(data)}> {/* While onclick open edit page.   */}
                            <Icons color="#52575a" icon="edit" /> {/* Edit icon.  */}
                          </Button>
                        </OverlayTrigger>
                        <OverlayTrigger overlay={
                          <Tooltip id="shipmaterial-delete"> Delete
                          </Tooltip>
                        }>
                          <Button className='link_button' onClick={() => handleShow(data)}>
                            <Icons color="#52575a" icon="delete" />
                          </Button>
                        </OverlayTrigger>
                      </TableActions>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            <TableFooter>
              <Text> {/* Display the total elements.  */}
                {displayShips.length === 1 && (
                  <>
                    <b>
                      {displayShips.length}
                      {/* {((page) * 10) + 1} - {(displayShips.length + (page) * 10)} */}
                    </b> of {totalElement} Ship Material
                  </>
                )}
                {displayShips.length > 1 && (
                  <>
                    <b>
                      {displayShips.length}
                      {/* {((page) * 10) + 1} - {(displayShips.length + (page) * 10)} */}
                    </b> of {totalElement} Ship Materials
                  </>
                )}
              </Text>
              <Pagination size="sm">
                {firstPage()} {/* First page button.   */}
                {prevBtn()} {/* Previous button.   */}
                {PageNumber} {/* Totalpages.   */}
                {nextBtn()} {/* Next button.   */}
                {lastPage()} {/* Last page button.   */}
              </Pagination>
            </TableFooter>
          </>
        )}
      </Card>
      {/* If modal is true goto the delete box with the props of onclose function */}
      <Modal show={showDelete} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            <Text variant='title-sm' color='main' bold>
              Confirmation
            </Text>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Text bold variant='confirmation' color='danger' values='Permanently you want to delete this item form ship Material list' />
        </Modal.Body>
        <Modal.Footer>
          <Button variant='transparent' onClick={handleClose}>
            <Icons icon="close" />
            Close
          </Button>
          <Button variant='transparent' onClick={() => _willDelete()}>
            <Icons icon="delete_forever" />
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </Main>
  )
}
export interface TablefooterProps {
  children?: React.ReactNode
}

// Table footer style.  
const TableFooter = (props: TablefooterProps) => {

  const tablefooter = classNames('tablefooter')

  return (
    <Flex jc='jc-between' className={tablefooter}>
      {props.children}
    </Flex>
  )

}

export interface TableActionsProps {
  children?: React.ReactNode
}

// Table body style.  
const TableActions = (props: TableActionsProps) => {

  const tableAction = classNames('tableAction')

  return (
    <Flex jc='jc-center' className={tableAction}>
      {props.children}
    </Flex>
  )

}

interface searchProps {
  children?: React.ReactNode
}

//Search Form Component  for displaying serarch box, and add ship button
const SearchForm = (props: searchProps) => {

  const search = classNames('serachForm')
  return (
    <form autoComplete='off' className={search}>
      {props.children}
    </form>
  )
}

// Declare the variable.  
const mapStateToProps = (state: any) => ({
  material: state.material.material,
  isLoading: state.material.isLoading,
  error: state.material.error,
  totalElement: state.material.totalElement,
  totalPage: state.material.totalPage
})

// Connect to the action and get the list, totalpage and total elements.  
export default connect(
  mapStateToProps,
  {
    shipMaterialListGetAction,
    shipMaterialSetSelectedAction,
  }

)(ShipMaterialList)